export default "__VITE_ASSET__BSkxo7TQ__"